// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5862":"596f07f6142378ddcbdc","6798":"8aa80e1db72f9a39a705","7471":"34493087eb2469ae6e25"}[chunkId] + "";
};